import { render, staticRenderFns } from "./RatingBanner.vue?vue&type=template&id=31ea9ffc&scoped=true&"
import script from "./RatingBanner.vue?vue&type=script&lang=js&"
export * from "./RatingBanner.vue?vue&type=script&lang=js&"
import style0 from "./RatingBanner.vue?vue&type=style&index=0&id=31ea9ffc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ea9ffc",
  null
  
)

export default component.exports